import { Component, OnInit, Input } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip } from 'rxjs'
import { concatMap, startWith, take } from 'rxjs/operators'
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ClaimClientRole,
  InteractService,
  IntimationService,
  ClaimRegistrationService,
  CommonUtilty,
  AppMetadataHandler,
  WorkqueueService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ComponentOutputDO, IntimationIO } from 'app/BaseFramework/shared/models';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import * as moment from 'moment/moment';
import { environment } from 'environments/environment';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-rules-auto',
  templateUrl: './rules-auto.component.html',
  styleUrls: ['./rules-auto.component.scss']
})
export class RulesAutoComponent implements OnInit {

  /**
   * <app-rules-auto *ngIf="payloadInEdit" [IO]="payloadInEdit"></app-rules-auto>
   */

  lookupsToBind = ["manualUwDecisionCd"]
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  listOfCategories = [];
  searchValue = '';
  decisionCategoryLookup = [];

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private validationUtilService: ValidationUtilService,
    private interactService: InteractService,
    private intimationService: IntimationService,
    private claimRegistrationService: ClaimRegistrationService,
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
    private arrayManipulations: ArrayManipulations
  ) { }

  _IO
  @Input()
  set IO(value: any) {
    if (value) {
      this._IO = this.commonUtilty.deepCopy(value)
      if (this.commonUtilty.isArrayIterable(this._IO.autoUwResults))
        this._IO.autoUwResults = this.arrayManipulations.getUniqueElements(this._IO.autoUwResults, 'ruleName')
    }
  }
  get IO() {
    return this._IO
  }
  environment = environment

  ngOnInit() {
    this.initializeInsuredList(this.IO);
    /** Demo: If in demo and there are less than 4 rules, then render dummyRules */
    this.setRulesDataAndFilters();
    
    this.createDecisionCategoryLookup();
    this.calculateCount();
    // this.lookup$['manualUwDecisionCd'].subscribe(lookup => {
    //   this.decisionCategoryLookup = lookup;
    //   this.decisionCategoryLookup.unshift({ lookupKey: 'ALL', lookupValue: 'All' })
    //   console.log("decisionCategoryLookup", JSON.stringify(this.decisionCategoryLookup));
    // });
  }

  createDecisionCategoryLookup(){
    if(this.commonUtilty.isArrayIterable(this.rulesData)){
      let tempArray = [];
      this.rulesData.forEach(element =>{
        if(tempArray.indexOf(element.decision) === -1 ){
          tempArray.push(element.decision);
        }
      });
      tempArray.forEach(element =>{
        this.decisionCategoryLookup.push({ lookupKey: element, lookupValue: element });
      });
      this.decisionCategoryLookup.unshift({ lookupKey: 'ALL', lookupValue: 'All' });
    }
  }

  positiveDecisionValue = ['ACCEPTED', 'ACCEPTED STANDARD', 'PASSED', 'STANDARD', 'Accepted', 'Passed'];
  negativeDecisionValue = ['REJECTED', 'FAILED', 'Rejected'];
  NeutralDecisionValue = ['REFER', 'REFERRED AND RATED', 'Refer'];
  IgnoreDecisionValue = ['DEFERRED'];

  positiveCount : number;
  negativeCount : number;
  decisionCountArray = [];
  calculateCount(){
    if(this.commonUtilty.isArrayIterable(this.decisionCategoryLookup)){
      this.decisionCategoryLookup.forEach(element => {
        if(element.lookupKey != 'ALL'){
          let count = this.rulesData.filter(item => element.lookupKey == item.decision).length;
          this.decisionCountArray.push({name:element.lookupKey, count: count});
        }
      });
    }
    //this.positiveCount = this.rulesData.filter(item => this.positiveDecisionValue.includes(item.decision)).length;
    //this.negativeCount = this.rulesData.filter(item => this.negativeDecisionValue.includes(item.decision)).length;
    
  }

  applyClass(name){
    if(this.positiveDecisionValue.includes(name)){
      return 'col-green'
    }else{
      return 'col-red'
    }
  }

  ruleCategories = [null]
  getRulesCategorized(ruleCategory) {
    if (environment['demo'] &&
      this.appMetadataHandler.featureFlags.enableBetaFeatures &&
      (this.IO.autoUwResults &&
        this.IO.autoUwResults.length < 4)) {
      return this.dummyRules
    }
    else
      return this.rulesDataFiltered.filter(rule => rule['ruleCategory'] === ruleCategory)
  }

  private setRulesDataAndFilters() {
    if (environment['demo'] && (this.IO.autoUwResults && Array.isArray(this.IO.autoUwResults) && this.IO.autoUwResults.length < 4)) {
      this.rulesData = this.dummyRules;
    }
    /** For Production: Real rules will be rendered */
    if (this.IO && this.commonUtilty.isArrayIterable(this.IO.autoUwResults)) {
      this.rulesData = this.IO.autoUwResults;
    }
    this.ruleCategories = this.rulesData.map(r => r.ruleCategory || r.category).filter((v, i, a) => a.indexOf(v) === i);
    this.getRuleCategoryUIFilter(this.ruleCategories);
    console.log("rule categories array", JSON.stringify(this.ruleCategories));
    this.rulesDataFiltered = this.IO ? this.rulesData.filter(x => x.decision) || [] : [];
    this.rulesPassedCount = this.rulesData.filter(x => x.decision && (x.decision.toLowerCase() == "standard" || x.decision.toLowerCase() == "accepted")).length;
    this.rulesFailedCount = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() != "standard").length;
    this.OverAllDecisionData(); 
  }

  showOverAllDecisionAlert : boolean = false;
  overAllDecisionContent:string = null;
  OverAllDecisionData(){
    let overAllDecision: number = this.rulesData.filter(item => this.negativeDecisionValue.includes(item.decision)).length +
                              this.rulesData.filter(item => this.NeutralDecisionValue.includes(item.decision)).length;
    if(overAllDecision > 0){
      this.overAllDecisionContent = "Given case is referred to underwriter.";
      this.showOverAllDecisionAlert = true;
    }
  }

  /* Rules */
  rulesData: Array<any> = [];
  rulesDataFiltered = [];
  rulesLoading: boolean = false;
  rulesRadio: any = "ALL";

  /* Counts */
  rulesPassedCount: number = null;
  rulesFailedCount: number = null;
  insuredList = [];


  dummyRules = [
    {
      "id": 2,
      "ruleName": "Product, duration, amount matrix rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Refer",
      "decisionVal": "Refer to Underwriting",
      "recco": "Referred for rule fail",
      "recommendation": "Check health disclosures",
      "category": "Product",
      "weight": 8,
      "conditions": [
        { "desc": "Check STP flag \"No\" from product master", "status": "PASS" },
        { "desc": "If Policy Age > 3 yrs (policy issuance & DGH reinstement date)", "status": "PASS" },
        { "desc": "If claim amount is <=5L", "status": "FAIL" }
      ]
    },
    {
      "id": 3,
      "ruleName": "Product and policy status matrix rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Refer",
      "decisionVal": "Refer to Underwriting",
      "recco": "Referred for rule fail",
      "category": "Product",
      "recommendation": null,
      "weight": 7,
      "conditions": [
        { "desc": "Check STP flag \"No\" from product master", "status": "PASS" },
        { "desc": "If policy status is 'Disc Fund' or 'Paid Up'", "status": "FAIL" }
      ]
    },
    {
      "id": 4,
      "ruleName": "Health History-Heart rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Passed",
      "decisionVal": "Pass",
      "category": "Family History",
      "weight": 5,
      "conditions": []
    },
    {
      "id": 5,
      "ruleName": "Adverse Family History Rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Passed",
      "decisionVal": "Pass",
      "category": "Family History",
      "weight": 5,
      "conditions": []
    },
    {
      "id": 1,
      "ruleName": "Auto-underwriting flag rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Refer",
      "decisionVal": "Refer to Underwriting",
      "recco": "Referred for auto-underwriting flag rule",
      "recommendation": "Auto underwriting failed. Please check all the rules marked as refer or failed",
      "category": "Straight-Through Processing",
      "weight": 9,
      "conditions": [
        { "desc": "Check STP flag \"Yes\" from product master", "status": "FAIL" }
      ]
    },
    {
      "id": 6,
      "ruleName": "Adventurous Activity Rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Failed",
      "decisionVal": "Pass",
      "recommendation": "Apply extra loading",
      "category": "Hobbies and Activity",
      "weight": 5,
      "conditions": []
    },
    {
      "id": 8,
      "ruleName": "Unhealthy Activity Rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Failed",
      "recommendation": "Request additional questionnaire",
      "decisionVal": "Pass",
      "category": "Hobbies and Activity",
      "weight": 5,
      "conditions": []
    },
    {
      "id": 7,
      "ruleName": "Health History: Diabetic Rule",
      "claimType": "Health",
      "ruleSubType": "Policy",
      "decisionType": "Rating",
      "decision": "Passed",
      "decisionVal": "Pass",
      "category": "Family History",
      "weight": 5,
      "conditions": []
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Black Listed Intermediary",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud-Intermediary",
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Higher Frequency from this agent",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud-Intermediary",
      "decisionType": "RATING",
      "decision": "Failed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": "Request further investigation of intermediary",
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "High lapsed ratio",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud",
      "decisionType": "RATING",
      "decision": "Failed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Loss Ratio of Sales Person",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud-Intermediary",
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Intermediary with High Claims Frequency",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud-Intermediary",
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Proposal coming in from a Branch with high Loss Ratio",
      "ruleSubType": "AUWPolicy",
      "category": "Fraud-Intermediary",
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Proposal coming in from a Branch with high frequency of claims",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured is matching with Fraud Customary",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Proposer matching with Fraud Customary",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Payer matching with Fraud Customary",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Fraudulent Pin Code Rule",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Failed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Client's Mobile Number is matching with providers",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Client's Mobile Number is matching with providers",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Married Individuals",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Disease Prone Age",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Sum Insured Limit",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Nominee matching with Fraud Customer Repository",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Nominee matching with Providers",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Appointee matching with Fraud Customer Repository",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Appointee matching with Providers",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "BMI Rule",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Medical Declaration by any of the Insured",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Annual Income with Sum Insured",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Previous Insurance Proposal",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Physician is Fraudulent",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Multiple Policies of same client",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured selecting all Optional Covers",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured Buying more than 1 Policy from different Channels",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured Buying more than 1 Policy from different advisors",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured smoking more than Defined Cigarattes",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Refer",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Referred to Underwriter",
      "recommendationCategory": null,
      "recommendation": "Referred for Insured smoking more than Defined Cigarattes",
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured drinking  more than Defined",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Refer",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Referred to Underwriter",
      "recommendationCategory": null,
      "recommendation": "Referred for Insured drinking  more than Defined",
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "CIBIL Score",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Passed",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Insured Occupation Rule",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Refer",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Referred to Underwriter",
      "recommendationCategory": null,
      "recommendation": "Aviation Profession",
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    }

  ]

  getRuleCategoryUIFilter(ruleCategories) {
    if (this.commonUtilty.isArrayIterable(ruleCategories)) {
      for (let i = 0; i < ruleCategories.length; i++) {
        let text = ruleCategories[i] ? ruleCategories[i].toLowerCase() : null;
        if(text !== null){
          let formattedText = text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
          let category = { text: formattedText, value: ruleCategories[i] };
          this.listOfCategories.push(category);
        }
      }
    }
  }

  filterRules(type?, clientId?) {
    if (type === 'ALL') this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
    else this.rulesDataFiltered = this.rulesData.filter(x => x.decision.toLowerCase() == type.toLowerCase());
    if (type) this.rulesRadio = type;
    // this.setRulesDataAndFilters()
    // switch (this.rulesRadio.toLowerCase()) {
    //   case 'all':
    //     this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
    //     break;
    //   case 'passed':
    //     this.rulesDataFiltered = this.rulesData.filter(x => x.decision && (x.decision.toLowerCase() == "standard" || x.decision.toLowerCase() == "accepted"));
    //     break;
    //   case 'failed':
    //     this.rulesDataFiltered = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() != "standard");
    //     break;
    // }
    /* Faker */
    this.rulesLoading = true;
    setTimeout(() => { this.rulesLoading = false }, 800);
    console.log("filterRules RUN");
  }


  filterAllRules(type?) {
    if (type) this.rulesRadio = type;
    switch (this.rulesRadio.toLowerCase()) {
      case 'all':
        this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
        break;
      case 'passed':
        this.rulesDataFiltered = this.rulesData.filter(x => x.decision && (x.decision.toLowerCase() == "standard" || x.decision.toLowerCase() == "passed"));
        break;
      case 'failed':
        this.rulesDataFiltered = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() != "standard");
        break;
    }
    /* Faker */
    this.rulesLoading = true;
    setTimeout(() => { this.rulesLoading = false }, 800);
    console.log("filterRules RUN");
  }
  initializeInsuredList(IO) {
    if (IO)
      this.insuredList = this.getAllInsuredsFromIO(IO);
  }

  getAllInsuredsFromIO(IO) {
    let output = []
    if (IO) {
      let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
      let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
      if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
        output.push(...PRIMARYINSUREDLIST);
      if (INSUREDLIST && Array.isArray(INSUREDLIST))
        output.push(...INSUREDLIST)
    }
    return output
  }

  filterRulesOnCategory(filterArray) {
    if (this.commonUtilty.isArrayIterable(filterArray)) {
      for (let fl = 0; fl < filterArray.length; fl++) {
        this.rulesDataFiltered = this.rulesData.filter(item => item.category === filterArray[fl]);
      }
    } else {
      this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
    }
  }

  searchRules(value) {
    if (value) {
      this.rulesDataFiltered = this.rulesData.filter(item => item.ruleName ? item.ruleName.toLowerCase().includes(value.toLowerCase()) : false);
    }
  }

  reset(): void {
    this.searchValue = '';
    this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
  }
}
